export default __webpack_public_path__ + "media/images/open-graph-image-c8ce66edb985062bdb935cc16b2b6fd9.jpg";